export var TypeActionShowMe;
(function (TypeActionShowMe) {
    TypeActionShowMe["QuestTaskStartProduction"] = "Show Me > QuestTaskStartProduction";
    TypeActionShowMe["QuestTaskHaveBuildings"] = "Show Me > QuestTaskHaveBuildings";
    TypeActionShowMe["QuestTaskCollectResource"] = "Show Me > QuestTaskCollectResource";
    TypeActionShowMe["QuestTaskHaveExpansion"] = "Show Me > QuestTaskHaveExpansion";
    TypeActionShowMe["QuestTaskFulfillContract"] = "Show Me > QuestTaskFulfillContract";
    TypeActionShowMe["QuestTaskBuyImprovement"] = "Show Me > QuestTaskBuyImprovement";
    TypeActionShowMe["QuestTaskUseHumus"] = "Show Me > QuestTaskUseHumus";
    TypeActionShowMe["QuestTaskUseOutskirt"] = "Show Me > QuestTaskUseOutskirt";
    TypeActionShowMe["QuestTaskEarnResource"] = "Show Me > QuestTaskEarnResource";
    TypeActionShowMe["QuestTaskSpendResource"] = "Show Me > QuestTaskSpendResource";
    TypeActionShowMe["SelectBuildingInfoInBuildMenu"] = "Show Me > SelectBuildingInfoInBuildMenu";
    TypeActionShowMe["ConsumeBuildingInfoInInBuildMenu"] = "Show Me > ConsumeBuildingInfoInInBuildMenu";
    TypeActionShowMe["MissingWorkers"] = "Show Me > MissingWorkers";
    TypeActionShowMe["InsufficientLevel"] = "Show Me > InsufficientLevel";
})(TypeActionShowMe || (TypeActionShowMe = {}));
export var actionShowMeQuestTaskStartProduction = function (taskType) { return ({
    taskType: taskType,
    type: TypeActionShowMe.QuestTaskStartProduction,
}); };
export var actionShowMeQuestTaskEarnResources = function (taskType) { return ({
    taskType: taskType,
    type: TypeActionShowMe.QuestTaskEarnResource,
}); };
export var actionShowMeQuestTaskCollectResource = function (taskType) { return ({
    taskType: taskType,
    type: TypeActionShowMe.QuestTaskCollectResource,
}); };
export var actionShowMeQuestTaskHaveBuildings = function (taskType) { return ({
    taskType: taskType,
    type: TypeActionShowMe.QuestTaskHaveBuildings,
}); };
export var actionShowMeQuestTaskHaveExpansion = function (taskType) { return ({
    taskType: taskType,
    type: TypeActionShowMe.QuestTaskHaveExpansion,
}); };
export var actionShowMeQuestTaskFulfillContract = function () { return ({
    type: TypeActionShowMe.QuestTaskFulfillContract,
}); };
export var actionShowMeQuestTaskBuyImprovement = function (taskType) { return ({
    taskType: taskType,
    type: TypeActionShowMe.QuestTaskBuyImprovement,
}); };
export var actionShowMeQuestTaskUseHumus = function () { return ({
    type: TypeActionShowMe.QuestTaskUseHumus,
}); };
export var actionShowMeQuestTaskUseOutskirt = function (taskType) { return ({
    taskType: taskType,
    type: TypeActionShowMe.QuestTaskUseOutskirt,
}); };
export var actionShowMeQuestTaskSpendResource = function (taskType) { return ({
    taskType: taskType,
    type: TypeActionShowMe.QuestTaskSpendResource,
}); };
export var actionShowMeSelectBuildingInfoInBuildMenu = function (tabId, buildingId) { return ({
    buildingId: buildingId,
    tabId: tabId,
    type: TypeActionShowMe.SelectBuildingInfoInBuildMenu,
}); };
export var actionShowMeConsumeBuildingInfoInInBuildMenu = function () { return ({
    type: TypeActionShowMe.ConsumeBuildingInfoInInBuildMenu,
}); };
export var actionShowMeMissingWorkers = function () { return ({
    type: TypeActionShowMe.MissingWorkers,
}); };
export var actionShowMeInsufficientLevel = function () { return ({
    type: TypeActionShowMe.InsufficientLevel,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/actionShowMe.ts
// module id = 63
// module chunks = 3